<template>
    <component v-bind:is="$store.state.current_view"></component>
</template>

<script>

import CoalViewMain from './views/CoalViewMain.vue'
import CoalViewMyNFTs from './views/CoalViewMyNFTs.vue'
import CoalViewListNFTs from './views/CoalViewListNFTs.vue'
import CoalViewListOnSale from './views/CoalViewListOnSale.vue'
import CoalViewMint from './views/CoalViewMint.vue'
import CoalViewHelp from './views/CoalViewHelp.vue'
import CoalViewMine from './views/CoalViewMine.vue'
import CoalViewHeists from './views/CoalViewHeists.vue'
import CoalViewDebug from './views/CoalViewDebug.vue'
import CoalViewSettings from './views/CoalViewSettings.vue'
import CoalViewTrack from './views/CoalViewTrack.vue'
import CoalViewSacrifice from './views/CoalViewSacrifice.vue'


export default {
    name: "CoalBody"
    , components: {
        CoalViewMain
        , CoalViewMyNFTs
        , CoalViewListNFTs
        , CoalViewListOnSale
        , CoalViewMint
        , CoalViewHelp
        , CoalViewMine
        , CoalViewHeists
        , CoalViewDebug
        , CoalViewSettings
        , CoalViewTrack
        , CoalViewSacrifice
    }
}

</script>

<style>

</style>